import sodium from "libsodium-wrappers";
import { Context, Effect, Layer } from "effect";
import { encodeBase64 } from "effect/Encoding";
export const make = Effect.gen(function*() {
    const generateSealingKeyPair = ()=>Effect.gen(function*() {
            yield* Effect.promise(()=>sodium.ready);
            const { publicKey, privateKey } = sodium.crypto_box_keypair();
            const uuid = crypto.randomUUID();
            const base64PrivateKey = sodium.to_base64(privateKey);
            const base64PublicKey = sodium.to_base64(publicKey);
            return {
                keyId: uuid,
                publicKey: base64PublicKey,
                privateKey: base64PrivateKey,
                publicKeyEncoded: encodeBase64(JSON.stringify({
                    keyId: uuid,
                    publicKey: base64PublicKey
                })),
                privateKeyEncoded: encodeBase64(JSON.stringify({
                    keyId: uuid,
                    privateKey: base64PrivateKey,
                    publicKey: base64PublicKey
                }))
            };
        });
    return {
        generateSealingKeyPair
    };
});
export class SealingKeyGeneratorService extends Context.Tag("@open-revenue/utils/SealingKeyGeneratorService")() {
    static Live = Layer.effect(this, make);
}
